import ScrollTriggerWrapper from "@/components/atoms/scrollTrigger";
import gsap from "gsap";
import ScrollTrigger from "gsap/src/ScrollTrigger";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import MenuButton from "./menuButton";
import DesktopMenu from "./desktopMenu";
import LogoButtonAnimation from "./logoButtonAnimation";
import LogoButton from "./desktopMenu/logoButton";
import { colors } from "@/components/atoms/colors";
import { useMediaQuery } from "@mui/material";

const Header = ({ settingAPI, isEventPage = false }) => {
  const pathname = usePathname();
  const [scrolled, setScrolled] = useState(
    pathname === "/" || isEventPage ? false : true,
  );
  const [openMenu, setOpenMenu] = useState(false);
  const [isAnimationComplete, setAnimationComplete] = useState(
    pathname !== "/" ? true : false,
  );

  const animationObj = {
    "(min-width: 1024px)": [
      () => {
        const id = "headerAnimation";
        const elem = "#logo";
        const settings = {
          scrollTrigger: {
            id: id,
            trigger: document.querySelector("#headerAnimation"),
            scrub: true,
            start: "top top",
            end: "+=50%",
          },
        };
        const animation = [
          {
            set: [
              elem,
              {
                bottom: 0,
                width: "100%",
                pointerEvents: "none",
              },
            ],
          },
          {
            to: [
              elem,
              {
                bottom: "calc(100svh - 84.25px)",
                width: 325,
                pointerEvents: "auto",
              },
              0,
            ],
          },
        ];
        return { id, elem, settings, animation };
      },
    ],
    "(max-width: 1023px)": [
      () => {
        const id = "headerAnimation";
        const elem = "#logo";
        const settings = {
          scrollTrigger: {
            id: id,
            trigger: document.querySelector("#headerAnimation"),
            scrub: true,
            start: "top top",
            end: "+=50%",
          },
        };
        const animation = [
          {
            set: [
              elem,
              {
                bottom: 0,
                width: "100%",
                pointerEvents: "none",
              },
            ],
          },
          {
            to: [
              elem,
              {
                bottom: "calc(100svh - 50.5px)",
                width: 150,
                pointerEvents: "auto",
              },
              0,
            ],
          },
        ];
        return { id, elem, settings, animation };
      },
    ],
  };

  useEffect(() => {
    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      gsap.globalTimeline.clear();
      gsap.killTweensOf("*");
    };
  }, []);

  useEffect(() => {
    if (pathname === "/" || isEventPage) {
      const onScroll = () => {
        setScrolled(window.scrollY > window.innerHeight - 50 ? true : false);
      };
      window.addEventListener("scroll", onScroll);

      return () => {
        window.removeEventListener("scroll", onScroll);
      };
    }
  }, []);

  useEffect(() => {
    if (!isAnimationComplete && pathname === "/") {
      document.body.classList.add("body-locked");
    } else {
      document.body.classList.remove("body-locked");
    }
  }, [isAnimationComplete]);

  useEffect(() => {
    setOpenMenu(false);
  }, [pathname]);

  return (
    <ScrollTriggerWrapper animation={animationObj} locomotive={false}>
      <header
        className={`w-full h-[70px] md:h-[100px] fixed top left-0 z-40 px-smallMobile md:px-mediumDesktop transition-all duration-500 ${
          !isAnimationComplete ? "pointer-events-none" : ""
        } ${scrolled ? "bg-background" : ""}`}
      >
        <nav className="w-full h-full max-w-1440 mx-auto flex justify-between items-center">
          <MenuButton
            onClick={() => setOpenMenu(!openMenu)}
            scrolled={scrolled}
          />
          {pathname === "/" ? (
            <LogoButtonAnimation
              scrolled={scrolled}
              onAnimationComplete={() => setAnimationComplete(true)}
            />
          ) : (
            <LogoButton color={scrolled ? colors.olive : colors.dune} />
          )}
          {useMediaQuery("(max-width: 767px)") ? (
            <p className="leading-[0] text-center">
              <MenuButton
                name={
                  <>
                    Book <br className="md:hidden" />& Join
                  </>
                }
                link="/book-join"
                scrolled={scrolled}
              />
            </p>
          ) : (
            <MenuButton
              name="Book & Join"
              link="/book-join"
              scrolled={scrolled}
              className="pb-[2px]"
            />
          )}
        </nav>
      </header>
      <DesktopMenu
        openMenu={openMenu}
        setOpenMenu={setOpenMenu}
        hideEventsPage={settingAPI.hideEventsPage}
      />
    </ScrollTriggerWrapper>
  );
};

export default Header;
